import { createFileRoute } from '@tanstack/react-router';

import { Browser } from 'src/apps/device/components';

export const Route = createFileRoute('/_auth/_layout/device/browser')({
  component: () => <Browser />,
});
